<template>
  <v-main class="ml-0 mt-2 mr-2">
    <div class="ml-2">
   
      <v-card max-width="100%" elevation="1">
      <v-alert
        style="max-height: 47px;!important"
        color="topo_menu"
        class="text-left"
      >
        <v-breadcrumbs :items="itemsBread">
          <template v-slot:divider>
            <v-icon>mdi-forward</v-icon>
          </template>
        </v-breadcrumbs>
      </v-alert>     
      
          <v-row class="mx-auto mt-0 ml-0 pa-5">

             <v-col cols="12" xl="2" lg="4" md="4" sm="6" xs="12">
              <v-autocomplete
                transition="fab-transition"
                :items="listaContas"
                v-model="lancamento.id_conta"
                name="conta"
                label="Escolha uma conta"
                item-value="id_conta"
                item-text="conta"
                filled
                @change="buscaLista()"
              
                hide-details
              ></v-autocomplete>
            </v-col>

           <v-col cols="12" xl="2" lg="2" md="2" sm="6" xs="6">
              <v-menu
                v-model="menu2"
                :close-on-content-click="false"
                transition="scroll-y-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="dateInicialFormatted"
                    label="data inicial"
                    persistent-hint
                    prepend-inner-icon="event"
                    filled
                    
                    v-on="on"
                    @input="
                      lancamento.data_final = parseDate(dateFinalFormatted);                      
                    "
                    
                    hide-details
                  ></v-text-field>
                </template>
                <v-date-picker
                  locale="pt-br"
                  v-model="lancamento.data_inicial"
                  no-title
                  @input="
                    menu2 = false;buscaLista()
                  
                  "
                  hide-details
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" xl="2" lg="2" md="2" sm="6" xs="12">
              <v-menu
                v-model="menuFin"
                :close-on-content-click="false"
                transition="scroll-y-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="dateFinalFormatted"
                    label="data final"
                    persistent-hint
                    prepend-inner-icon="event"
                    filled
                    
                    v-on="on"
                    @input="
                      lancamento.data_final = parseDate(dateFinalFormatted);
                      ;
                    "
                   
                    hide-details
                  ></v-text-field>
                </template>
                <v-date-picker
                  locale="pt-br"
                  v-model="lancamento.data_final"
                  no-title
                  @input="menuFin = false;buscaLista()"
                  hide-details
                ></v-date-picker>
              </v-menu>
            </v-col>

           
            
             <v-col cols="6" xl="1" lg="1" md="2" sm="6" xs="1">
                  <v-btn
                      
                      color="error"
                      @click="gerarPdf()"
                      outlined
                      small
                    >
                    <v-icon>mdi-pdf-box</v-icon>
                    </v-btn>                    
            </v-col>
            <v-col cols="6" xl="1" lg="1" md="2" sm="6" xs="1">
              <v-btn
                      
                      color="success"
                      @click="gerarExcel()"
                      outlined
                      small
                    >
                    <v-icon>mdi-microsoft-excel</v-icon>
                    </v-btn>
            </v-col>
          </v-row>
          
      
    </v-card>
      <v-card class="mt-5">
       <v-card-title>
          <h6>Saldo Anterior: {{saldoAnterior}}</h6>
      <v-spacer></v-spacer>
       </v-card-title>
     <v-row no-gutters>
      <v-col style="padding:6px 0px 6px 0px!important" cols="12" xl="12" lg="12" md="12" sm="12" xs="12">
           
    
      <v-data-table
        :headers="headers"
        :items="lista"
        :loading="loading_table"
        :search="search"
        dense
        no-data-text="Nenhum resultado encontrado!"
        no-results-text="Nenhum resultado encontrado!"
        class="elevation-1"
      >
        <template v-slot:item.data_operacao="{ item }">
              <span>{{ formatDate(item.data_operacao) }}</span>
        </template>
        <template v-slot:item.data_lancamento="{ item }">
              <span>{{ formatDate(item.data_lancamento) }}</span>
        </template>
        <template v-slot:item.debito="{ item }">
              <span>{{ formatar_valor(item.debito) }}</span>
        </template>
           <template v-slot:item.saldo="{ item }">
              <span>{{ formatar_valor(item.saldo) }}</span>
        </template>
        <template v-slot:item.credito="{ item }">
          <span>{{ formatar_valor(item.credito) }}</span>
        </template>
       <template v-slot:item.actions="{ item }">
              <v-icon
                color="primary"
                small
                class="mr-2"
                @click="editItem(item)"
              >
                mdi-pencil
              </v-icon>
              <v-icon color="error" small @click="deleteItem(item)">
                mdi-delete
              </v-icon>
            </template>
       
      </v-data-table>  
   
    
     </v-col>
    </v-row>
    </v-card>
    </div>
     <v-dialog v-model="dialogDelete" max-width="600px">
      <v-card>
        <v-card-title class=""
          >Tem certeza que deseja excluir este Registro?</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialogDelete=false">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="deleteItemConfirm"
            >OK</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
         <a href="#" target="_blank" id="linkDownload" download></a>
  </v-main>
  
  </v-container>
</template>

<script>
var moment = require("moment");

import { formata } from "../plugins/format";
//import DialogItensLancamento from "./DialogItensLancamento.vue";
const auth = {
  headers: {
    Authorization: "bearer " + window.sessionStorage.getItem("token"),
  },
};
export default {
  name: "Extrato",
  mixins: [formata],
    props: {
    source: String,
  },
  mounted() {
    // this.buscaGrupos();
    //this.buscaSaldos();
    this.buscaContas();

    // setTimeout(() => this.buscaContasPagar(), 500);

    //  this.buscaTipoDoc();
  },
  data: (vm) => ({
    valorSel: null,
    selFormaPagto: "",
    tipo_data: "vencimento",
    dialogItens: false,
    id_pai: "",
    lancamento: {
      descricao: "",
      id_fin_grupo_departamento: "",
      vlr_valor: "",
      data_pagamento: moment().format("YYYY-MM-DD"),
      data_inicial: moment().format("YYYY-MM-01"),
      data_final: moment().format("YYYY-MM-DD"),

      id_conta: "",
    },
      itemsBread: [
      {
        text: "Financeiro",
        disabled: true,
        href: "breadcrumbs_dashboard",
      },
      {
        text: "Extrato",
        disabled: false,
        href: "/dashboard/Extrato",
      },
    ],
    selDel: "",
    dialogDelete: false,
    barSaldos: true,
    barTabela: false,
    isLoading: false,
    // date_ini: moment().format("YYYY-MM-01"),
    //date_vencimento: new Date().toISOString().substr(0, 10),
    //date_pagamento: new Date().toISOString().substr(0, 10),
    datePagamentoFormatted: moment().format("DD/MM/YYYY"),
    //data_inicial: moment().format("YYYY-MM-01"),
    //data_final: new Date().toISOString().substr(0, 10),
    dateInicialFormatted: moment().format("01/MM/YYYY"),
    dateFinalFormatted: moment().format("DD/MM/YYYY"),
    menu1: false,
    menu2: false,
    menu3: false,
    menuFin: false,
    loading_table: false,
     search: "",
    loading_filtrar: false,
    loading_baixar: false,
    //grupos: [],

    historicos: [],
    fornecedores: [],
    listaTipoDoc: [],
    lista:[],
    
    saldoAnterior:0,
    headers: [
       {
        text: "Data Operação",
        value: "data_operacao",
        align: "left",
      },
       {
        text: "Data Lançamento",
        value: "data_lancamento",
        align: "left",
      },
      {
        text: "Histórico",
        value: "descricao",
      },
       {
        text: "Nº Doc",
        value: "documento",
        align: "left",
      },
      {
        text: "Crédito",
        value: "credito",
        align: "right",
      },  
      {
        text: "Débito",
        value: "debito",
        align: "right",
      },
     
             
      {
        text: "Saldo",
        value: "saldo",
        align: "right",
        
      },
    ],
    listaContas: [],
    v_autoselect: null,
   
  }),
  computed: {
    dateInFormatted() {
      return this.formatDate(this.lancamento.data_lancamento);
    },
    /*dateVencimentoFormatted() {
      return this.formatDate(this.lancamento.data_vencimento);
    },*/
  },
  mounted(){
    this.buscaLista();
    this.buscaContas();
  },

  watch: {
    v_autoselect(val) {
      console.log("auto" + val);
    },
    "lancamento.data_inicial"(val) {
      this.dateInicialFormatted = this.formatDate(this.lancamento.data_inicial);
    },
    "lancamento.data_final"(val) {
      this.dateFinalFormatted = this.formatDate(this.lancamento.data_final);
    },
    "lancamento.data_pagamento"(val) {
      this.datePagamentoFormatted = this.formatDate(
        this.lancamento.data_pagamento
      );
    },
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    dialogItens(val) {
      if (val == true) {
        this.buscaDadosItens();
      }
    },
  },
  methods: {
    gerarExcel(){
      
      this.buscaExtratoExcel()
    },
    gerarPdf(){
       this.buscaExtratoPdf();
    },
    buscaExtratoPdf() {
      this.loading = true;
      axios.post(
          `/fin/conta/extrato/pdf`,
          {
            cnpj: window.sessionStorage.getItem("cnpj"),
            data_inicial: this.lancamento.data_inicial,
            data_final: this.lancamento.data_final,
            id_conta: this.lancamento.id_conta,
          }
       ).then(response => {
        if (response.data.error) {
          this.textSnack = response.data.error;
          this.snackbar = true;
          this.lista = []
        } else {
          document.getElementById("linkDownload").href = response.data.url;
          document.getElementById("linkDownload").click();
        }
        this.loading = false;
      });
    },
    buscaExtratoExcel() {
      this.loading = true;
      axios.post(
          `/fin/conta/extrato/excel`,
          {
            cnpj: window.sessionStorage.getItem("cnpj"),
            data_inicial: this.lancamento.data_inicial,
            data_final: this.lancamento.data_final,
            id_conta: this.lancamento.id_conta,
          }
       ).then(response => {
        if (response.data.error) {
          this.textSnack = response.data.error;
          this.snackbar = true;
          this.lista = []
        } else {
          document.getElementById("linkDownload").href = response.data.url;
          document.getElementById("linkDownload").click();
        }
        this.loading = false;
      });
    },
    buscaContas(val) {
      this.listaContas = [];
      axios
        .post(
          `/fin/conta/lista`,
          {
            cnpj: window.sessionStorage.getItem("cnpj"),
          },
          auth
        )
        .then((response) => {
          this.listaContas = response.data;
        });
    },
    zeraCampos() {
      //   alert("campos");
      this.lancamento.id_conta = "";
      this.valorSel = "";
    },
    mudaTab(tab) {
      //alert("conta" + conta);
      //this.conta;
      //this.lancamento.id_conta = e;
      //alert(e);
      //  this.$refs.lancamento.selConta(e);
      this.$emit("mudaTab", tab);
    },
    atrribuirConta(val) {
      this.valorSel = val;
      for (let [key, value] of Object.entries(this.listaContasPagar)) {
        //console.log(`${key}: ${value}`);
        this.listaContasPagar[key].id_conta = val;
        //this.listaContasPagar[key].data_pagamento = val;
      }
    },
    addContaItem(id_lancamento, index, e) {
      // this.lancSelPagar.push({ id_lanc: id_lancamento, conta: e });
      //alert(id_lancamento);
      //  alert(e.target.value);
      // console.log("indkkk" + index);
      // console.log(this.lancSelPagar);
      this.listaContasPagar[index].id_conta = e;
    },
    buscaDadosItens() {
      setTimeout(
        () => this.$refs.dialogIt.buscaLancamentosFilhos(this.id_pai),
        300
      );
    },
    openFilhos(id_pai) {
      this.id_pai = id_pai;
      setTimeout(() => (this.dialogItens = true), 200);
    },
    closePagar() {
      this.dialogPagar = false;
    },
    showPagar(item) {
      if (
        this.lancamento.data_pagamento == "" ||
        this.lancamento.data_pagamento == null
      ) {
        alert("informe a data de pagamento");
        return false;
      }
      this.selPagar = item;
      console.log(this.selPagar);
      this.dialogPagar = true;
    },
   
    deleteItem(item) {
      console.log(item);
      console.log(item.id_lancamento);
      //this.editedIndex = this.lancamento.indexOf(item);
      //this.editedItem = Object.assign({}, item);
      this.selDel = item.id_lancamento;
      this.dialogDelete = true;
    },
    deleteItemConfirm() {
      this.listaLancamentos.splice(this.editedIndex, 1);
      this.closeDelete();
      axios
        .post(
          `/fin/lancamento/remove`,
          { id: this.selDel, cnpj: window.sessionStorage.getItem("cnpj") },
          auth
        )
        .then((response) => {
          this.selDel = "";
          this.buscaContasPagar();
          console.log(response);
          //this.grupos = response.data;
        });
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    editItem(item) {
      this.lancamento = item;
    },
    formata_moeda(val) {
      let valor = this.formatar_moeda(val);
      return valor;
    },
    addDescricao(val) {
      this.lancamento.descricao = val;
    },
    selecionarConta(id) {
      this.lancamento.id_conta = id;
      //  sessionStorage.setItem("selconta", id);
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    getStatus(status) {
      if (status === "Cancelada") {
        return "cancelada";
      }
    },

    selConta(e) {
      console.log(e);
      //this.lancamento.id_conta = e;
      // alert(e);
      //this.$refs.lancamento.selConta(e);
    },
    buscaSaldos() {
      this.$refs.saldos.buscaSaldos();
    },
    filtroBuscar() {
      setTimeout(() => this.buscaContasPagar(), 500);
    },
    buscaLista() {
       
      this.loading_table = true;
      axios
        .post(
          `/fin/conta/extrato`,
          {
            cnpj: window.sessionStorage.getItem("cnpj"),
            data_inicial: this.lancamento.data_inicial,
            data_final: this.lancamento.data_final,
            id_conta: this.lancamento.id_conta,
          }
        )
        .then((response) => {
          this.lista = response.data.dados;
          this.saldoAnterior = response.data.saldoAnterior;
          this.loading_table = false;
        }).catch((e) => {
          
          this.loading_table = false;
          this.lista = []
        });;
    },
    filtrarData() {
      this.filtroBuscar();
    },
    buscaContas(val) {
      this.listaContas = [];
      axios
        .post(
          `/fin/conta/lista`,
          {
            cnpj: window.sessionStorage.getItem("cnpj"),
          },
          auth
        )
        .then((response) => {
          this.listaContas = response.data;
        });
    },
  },
  /*removeConta() {
    alert("remove");
  },*/
};
</script>
<style scoped>
.ativa {
  border: 2px solid #000 !important;
}
</style>
